export default __webpack_public_path__ + "static/media/create-template-img-placeholder-3.37482958.jpg";